import React, {useState} from "react";
import {Button, Modal, Upload, Spin, App} from "antd";
import {UploadOutlined} from "@ant-design/icons";
import jwtAxios from "../../../../auth/jwt-api";
import translate from "../../../../i18n/translate";

export default function OfflineContractUpload({order, refetchInfo}) {
  const {message} = App.useApp();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const contract = order?.contracts?.[0];
  const shouldShow = contract &&
    contract.myid_key_director === null &&
    contract.myid_key_client === null &&
    contract.my_signature === false;

  if (!shouldShow) return null;

  return (
    <>
      <Button
        type="primary"
        onClick={() => setOpen(true)}
        style={{marginBottom: 10, width: "100%"}}
      >
        {translate("button.offline_contract")}
      </Button>
      <Modal
        title={translate("offline_contract.title")}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        destroyOnClose
      >
        <Upload.Dragger
          name="file"
          maxCount={1}
          beforeUpload={() => false}
          onChange={async (info) => {
            const file = info.file;
            if (!file || file.status === 'removed') return;
            setLoading(true);
            try {
              const formData = new FormData();
              formData.append('file', file.originFileObj || file);
              const uploadRes = await jwtAxios.post('/media/upload-offline-contract', formData, {
                headers: {"Content-Type": "multipart/form-data"},
              });
              const contractFileUrl = uploadRes?.data?.data?.media?.url;
              const contractId = contract.id;
              await jwtAxios.patch(`/contract/offline-contract/${contractId}`, {
                contract_file: contractFileUrl
              });
              message.success(translate("offline_contract.success"));
              setOpen(false);
              refetchInfo();
            } catch (error) {
              message.error(error.response?.data?.error || translate("message.error.occurred"));
            } finally {
              setLoading(false);
            }
          }}
          disabled={loading}
        >
          <p className="ant-upload-drag-icon">
            <UploadOutlined/>
          </p>
          <p className="ant-upload-text">{translate("offline_contract.upload_text")}</p>
        </Upload.Dragger>
        {loading && (
          <div style={{textAlign: 'center', marginTop: 16}}>
            <Spin/>
          </div>
        )}
      </Modal>
    </>
  );
}